import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { connect } from 'react-redux';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import { getAssessments } from './ducks/AssessmentActions';

class AssessmentAdd extends React.Component {
  constructor(props) {
    super(props);

    this.clientId = props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getAssessments(this.clientId);
  }

  render() {
    const { client, assessments } = this.props;

    return (
      client &&
      assessments && (
        <div className="client-form-pages">
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href={`/clients/${client.id}`}>
                {`${client.first_name} ${client.last_name}`}
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Add Assessment</Breadcrumb.Item>
            </Breadcrumb>
            <div className="page-title">
              <h4>Assessments</h4>
            </div>
            <div className="add-assessment-page">
              {assessments.length < 1 && (
                <ul>
                  <li className="list-head">
                    <Link
                      to={`/clients/${client.id}/add-assessment/first-session`}
                    >
                      First Session <i className="fas fa-chevron-right"></i>
                    </Link>
                  </li>
                  <li>Gender</li>
                  <li>Age</li>
                  <li>Weight</li>
                  <li>Height</li>
                  <li>Chest</li>
                  <li>Waist</li>
                  <li>Hips</li>
                  <li>Upper Leg</li>
                  <li>Calf</li>
                  <li>Upper Arm</li>
                  <li>Body Fat Percentage</li>
                  <li>Functional Movement Screening</li>
                  <li>Progress Photos</li>
                </ul>
              )}
              <ul className={assessments.length < 1 ? 'disabled' : ''}>
                <li className="list-head">
                  {assessments.length < 1 ? (
                    <span>
                      Progress Check-In <i className="fas fa-chevron-right"></i>
                    </span>
                  ) : (
                    <Link
                      to={`/clients/${client.id}/add-assessment/progress-check-in`}
                    >
                      Progress Check-In <i className="fas fa-chevron-right"></i>
                    </Link>
                  )}
                </li>
                <li>Weight</li>
                <li>Body Fat Percentage</li>
                <li>Height</li>
                <li>Chest</li>
                <li>Waist</li>
                <li>Hips</li>
                <li>Upper Leg</li>
                <li>Calf</li>
                <li>Upper Arm</li>
                <li>Progress Photos</li>
              </ul>
            </div>
          </div>
        </div>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    assessments: state.assessmentsReducer.assessments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getAssessments: clientId => dispatch(getAssessments(clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentAdd);
